<div *ngIf="showSessionTimer" (click)="openDialog()" class="btn btn-info w-100">
  {{ "sessionExpiresIn" | translate }} {{ time$ | async }}
</div>
